import { createTheme } from "@mui/material/styles";

const theme = createTheme();

export default createTheme({
  ...theme,
  typography: {
    fontFamily: ['"Montserrat"', "sans-serif"].join(","),
    root: {
      fontFamily: ['"Montserrat"', "sans-serif"].join(","),
    },
  },
  palette: {
    primary: {
      main: "#000",
    },
    secondary: {
      main: "#e6401e",
    },
    third: {
      main: "#fff",
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          [theme.breakpoints.down("sm")]: {
            padding: "14px 14px",
          },
        },
      },
    },
  },
  overrides: {
    MuiOutlinedInput: {
      input: {
        padding: "14px 14px",
      },
    },
    MuiTab: {
      root: {
        fontFamily: ['"Montserrat"', "sans-serif"].join(","),
        fontWeight: "700",
        fontSize: "1rem",
        "&.MuiTab-root": {
          color: "rgba(0,0,0,0.8)",
        },
      },
    },
  },
});
